import { resolveAssetPath } from '../../../utils/resolveAssetPath';
import './ImagePreview.css';

function ImagePreview({ src, size = 64 }) {
  const resolved = resolveAssetPath(src);
  if (!resolved) {
    return (
      <div className="admin-image-preview admin-image-preview-empty" style={{ width: size, height: size }}>
        —
      </div>
    );
  }
  return (
    <img
      src={resolved}
      alt=""
      className="admin-image-preview"
      style={{ width: size, height: size }}
      onError={(e) => {
        e.target.style.visibility = 'hidden';
      }}
    />
  );
}

export default ImagePreview;
